
import { useState, useEffect, useRef, useContext, createContext } from "react";
import { useNavigate } from "react-router-dom";


import { useUser } from "./UserContext";

import { EngagementTypeSelector, ProgramSelector, SubjectSelector } from "@Beasted1010/pivotal-wisdom";


export {
  CoachingScheduleContextProvider,
  useCoachingSchedule, useCoachingScheduleUpdate
};


const CoachingScheduleContext = createContext<any>( null ); // TODO: Properly fill out
const CoachingScheduleUpdateContext = createContext<any>( null );


function useCoachingSchedule() {
  return useContext( CoachingScheduleContext );
}

function useCoachingScheduleUpdate() {
  return useContext( CoachingScheduleUpdateContext );
}



enum AppointmentType { // TODO: Duplicated (e.g. Coaching.tsx Page)
  RECURRING = "Recurring",
  ADHOC = "Adhoc",
}



type CoachingScheduleContextProps = {
  children?: JSX.Element | JSX.Element[];
}


// TODO: Rename to SubjectContext ??? - But it does only have subjectData out of necessity to get programData
function CoachingScheduleContextProvider( {children}: CoachingScheduleContextProps ) {
  // Provider handles...

  // ... Creating State
  const navigate = useNavigate();

  const [ availabilityDataByMonth, setAvailabilityDataByMonth ] = useState<any[]>(); // TODO: TYPE

  const [ selectedAppointmentType, setSelectedAppointmentType ] = useState<any | undefined>( undefined );

  const [ selectedEventId, setSelectedEventId ] = useState<any>(); // TODO: TYPE...
  const [ selectedRecurringInstance, setSelectedRecurringInstance ] = useState<any>(); // TODO: TYPE...



  const [loading, setLoading] = useState( true );

  const { user } = useUser();


  // ... Updating State
  useEffect( () => {

    const abortController = new AbortController();
    async function getScheduleData() {
    }

    getScheduleData();


    setLoading( false );

    return () => {
      abortController.abort();
    }
    // TODO: Will "Loading" as part of Dependency Array cause repeated renders?
  }, []);




  const selectAppointmentType = ( appointmentTypeSelector: any ) => { // TODO: Proper Typing for Session Type Selector
    setSelectedAppointmentType( appointmentTypeSelector );
  }

  const selectEventId = ( eventId: string ) => {
    setSelectedEventId( eventId );
  }

  const selectRecurringInstance = ( recurringInstance?: any ) => { // TODO: TYPE
    setSelectedRecurringInstance( recurringInstance );
  }




  // ... Persisting State down into Children
  return (
    /* TODO: Split this up into other Contexts, such as one for ScheduleContext -- so not have such long & slightly irrelevant props passed via `value` prop */
    <CoachingScheduleContext.Provider value={ {selectedAppointmentType, selectedEventId, selectedRecurringInstance, availabilityDataByMonth} } >
      <CoachingScheduleUpdateContext.Provider value={ {selectAppointmentType, selectEventId, selectRecurringInstance, setAvailabilityDataByMonth} } >

        {
          loading ?
            <h1>Loading...</h1>
          :
            children
        }

      </CoachingScheduleUpdateContext.Provider>
    </CoachingScheduleContext.Provider>
  )
}


// ================================= HELPERS =================================






/* */
